export default "__VITE_ASSET__Bs328EJq__"